"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tarano": {
    "a06b9d6c": [{
      "hkey": "2f47eb9a",
      "slug": "borgonuovo-baracche-di-san-polo",
      "name": "Borgonuovo (Baracche di San Polo)",
      "primary": true,
      "skipSearch": false
    }],
    "baracche-di-san-polo-borgonuovo": [{
      "hkey": "2f47eb9a",
      "slug": "borgonuovo-baracche-di-san-polo",
      "name": "Borgonuovo (Baracche di San Polo)",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "600877fe": [{
      "hkey": "706628ee",
      "slug": "san-giorgio-baracche-di-tarano",
      "name": "San Giorgio (Baracche di Tarano)",
      "primary": true,
      "skipSearch": false
    }],
    "baracche-di-tarano-borgo-san-giorgio": [{
      "hkey": "706628ee",
      "slug": "san-giorgio-baracche-di-tarano",
      "name": "San Giorgio (Baracche di Tarano)",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;